export default api => {
  return {
    /**
     * Returns a list of domains for the current user.
     */
    async listDomains(params = {}) {
      const { data } = await api.get(`/api/v3/domains`, { params })

      return data
    },

    /**
     * Returns an array of agreements for the given TLDs.
     *
     * @param {{ tlds: string[], privacy: boolean }} params
     */
    async listAgreements(params = {}) {
      const { data } = await api.get(`/api/v3/domains/agreements`, { params })

      return data
    },

    /**
     * Returns a required schema object for the given TLD.
     *
     * @param {string} tld
     */
    async fetchTldSchema(tld) {
      const data = await api.get(`/api/v3/domains/purchase/schema/${tld}`)

      return data
    },

    /**
     * Performs SSO into the domain.
     */
    async sso() {
      const { data } = await api.post(`/api/v3/domains/sso`)

      const form = document.createElement('form')
      form.setAttribute('method', 'post')
      form.setAttribute(
        'action',
        process.env.GODADDY_SSO_URL + '/v1/federation'
      )

      const input = document.createElement('input')
      input.setAttribute('type', 'hidden')
      input.setAttribute('name', 'saml')
      input.setAttribute('value', data)

      form.appendChild(input)

      document.body.appendChild(form)

      form.submit()

      document.body.removeChild(form)
    },
  }
}
